import type { EndpointResponse } from '../client/response';

export const unwrapResponseBody = <Response extends EndpointResponse>(
  promise: Promise<Response>,
): Promise<Response['body']> => promise.then((response) => response.body);
